import { useGetTemplateQuery } from '../screens/Configuration/apiTemplate';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetCalculationQuery } from '../screens/CalculationDetail/apiCalculationDetail';
import { useMemo } from 'react';
import { TemplateOrCalculationType } from '../apis/api';
import { useTemplateOrCalculationWithValue } from './useTemplateOrCalculationWithValue';

export const useApplicationDate = (forcedType?: TemplateOrCalculationType): Date | undefined => {
  const templateOrCalculation = useTemplateOrCalculationWithValue(forcedType);
  const { data: templateData } = useGetTemplateQuery(
    templateOrCalculation.type === 'Template' && templateOrCalculation.hasValidValue
      ? templateOrCalculation.id
      : skipToken,
  );
  const { data: calculationData } = useGetCalculationQuery(
    templateOrCalculation.type === 'Calculation' && templateOrCalculation.hasValidValue
      ? templateOrCalculation.id
      : skipToken,
  );

  return useMemo(() => {
    let date: Date | undefined = undefined;
    if (templateOrCalculation.hasValidValue) {
      if (templateOrCalculation.type === 'Template') {
        if (templateData) {
          date = new Date(templateData.applicationDate);
        }
      } else {
        if (calculationData) {
          date = new Date(calculationData.applicationDate);
        }
      }
    }

    return date;
  }, [
    calculationData,
    templateData,
    templateOrCalculation.hasValidValue,
    templateOrCalculation.type,
  ]);
};
